// One-page checkout pop-up (snippets/cur-checkout.liquid), prietenbebe layout.
// Renders the live cart (lines with +/−/×, discount, subtotal, shipping, total, replacement-heads add-on)
// and remembers the customer's details in this browser.
// - "Plata la livrare": the order is created directly by our COD app (cod-form on api.magazinultarii.ro,
//   Shopify draft order → payment pending), no Shopify checkout. If the app can't take it (store/server
//   error), it falls back to Shopify's checkout below so no order is lost.
// - "Card": saves the details on the cart and continues to Shopify's checkout with every field pre-filled
//   via checkout[...] URL params.
// Cart helpers come from assets/cur-cart.js via window.curCart (one module instance; a relative import
// would load a second copy under another URL and double its click handlers).
const { addLines, refreshCart } = window.curCart || {};

const dlg = document.querySelector('[data-cur-checkout]');
if (dlg) {
  const cfg = JSON.parse(document.querySelector('[data-cur-co-config]').textContent);
  const gift = JSON.parse(document.querySelector('[data-cur-gift-config]')?.textContent || '{"variant":0,"min":0}');
  const form = dlg.querySelector('[data-cur-co-form]');
  const $ = (s) => dlg.querySelector(s);
  const lei = (c) => `${(c / 100).toLocaleString('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} lei`;
  const esc = (s) => String(s ?? '').replace(/[&<>"]/g, (m) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]));
  const KEY = 'cur-checkout-details';
  let cart = null;

  const post = (url, body) => fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then((r) => r.json());
  const load = async () => { cart = await (await fetch('/cart.js')).json(); return cart; };

  function render() {
    if (!cart || cart.item_count === 0) { dlg.close(); return; }
    $('[data-cur-co-count]').textContent = cart.item_count;
    $('[data-cur-co-lines]').innerHTML = cart.items.map((i) => `
      <div class="cur-co__line" data-key="${i.key}">
        ${i.image ? `<img src="${esc(i.image)}&width=160" alt="" width="64" height="64">` : '<span></span>'}
        <div class="cur-co__line-info">
          <p class="cur-co__line-name">${esc(i.product_title)}${i.variant_title && !/default/i.test(i.variant_title) ? ` <span>${esc(i.variant_title)}</span>` : ''}</p>
          <p class="cur-co__line-price">${lei(i.final_price)}${i.original_price > i.final_price ? ` <s>${lei(i.original_price)}</s>` : ''}</p>
          <div class="cur-co__qty"><button type="button" data-q="-1" aria-label="Mai puțin">−</button><span>${i.quantity}</span><button type="button" data-q="1" aria-label="Mai mult">+</button></div>
        </div>
        <button type="button" class="cur-co__rm" data-q="0" aria-label="Șterge">×</button>
      </div>`).join('');

    const discount = cart.total_discount || 0;
    const goods = cart.total_price;
    const ship = goods >= cfg.freeFrom ? 0 : cfg.shipping;
    $('[data-cur-co-sub]').textContent = lei(cart.original_total_price ?? goods + discount);
    $('[data-cur-co-disc-line]').hidden = !discount;
    $('[data-cur-co-disc-amt]').textContent = `−${lei(discount)}`;
    $('[data-cur-co-shipping]').textContent = ship ? lei(ship) : 'Gratuit';
    $('[data-cur-co-total]').textContent = lei(goods + ship);
    const left = cfg.freeFrom - goods;
    $('[data-cur-co-ship]').classList.toggle('is-free', left <= 0);
    $('[data-cur-co-ship-text]').innerHTML = left > 0 ? `Mai ai nevoie de <strong>${lei(left)}</strong> pentru livrare GRATUITĂ` : '✓ Ai livrare GRATUITĂ';
    $('[data-cur-co-ship-bar]').style.width = `${left <= 0 ? 100 : Math.min(100, Math.round((goods / cfg.freeFrom) * 100))}%`;

    // Goal offers (same rule as the cart drawer): for each goal not reached yet — free shipping, then the
    // gift — the cheapest pack whose price alone closes the gap, else the biggest. Both goals met: one
    // refill pack, until refills are in the cart.
    const shipGap = cfg.freeFrom - goods;
    const giftBase = cart.items.filter((i) => i.variant_id !== gift.variant).reduce((s, i) => s + i.final_line_price, 0);
    const giftGap = gift.variant ? gift.min - giftBase : 0;
    const pool = cfg.offers;
    const pickFor = (gap) => pool.find((o) => o.price >= gap) || pool[pool.length - 1];
    const picks = [];
    for (const gap of [shipGap, giftGap]) {
      if (gap <= 0 || !pool.length) continue;
      const p = pickFor(gap);
      if (!picks.includes(p)) picks.push(p);
    }
    const hasRefill = cart.items.some((i) => i.product_id === cfg.refillProduct);
    if (!picks.length && !hasRefill) { const r = pool.find((o) => o.refill); if (r) picks.push(r); }
    const goal = (o) => {
      const s = shipGap > 0 && o.price >= shipGap, g = giftGap > 0 && o.price >= giftGap;
      return s && g ? '→ livrare gratuită + cadou' : s ? '→ livrare gratuită' : g ? '→ primești cadoul' : '';
    };
    $('[data-cur-co-offers]').hidden = !picks.length;
    $('[data-cur-co-offer-list]').innerHTML = picks.map((o) => `
      <label class="cur-co__offer">
        <input type="checkbox" data-offer="${o.id}">
        ${o.image ? `<img src="${esc(o.image)}" alt="" width="52" height="52">` : ''}
        <span>Adaugă <strong>${esc(o.title)}</strong> la <strong>${lei(o.price)}</strong>${goal(o) ? `<em class="cur-co__goal">${goal(o)}</em>` : ''}</span>
      </label>`).join('');
  }

  const change = async (key, quantity) => {
    dlg.classList.add('is-busy');
    cart = await post('/cart/change.js', { id: key, quantity });
    if (await window.curCart?.syncGift?.()) await load();
    dlg.classList.remove('is-busy');
    render();
    refreshCart().catch(() => {});
  };

  dlg.addEventListener('click', async (e) => {
    const q = e.target.closest('[data-q]');
    if (q) {
      const line = q.closest('[data-key]');
      const item = cart.items.find((i) => i.key === line.dataset.key);
      const n = q.dataset.q === '0' ? 0 : Math.max(0, item.quantity + Number(q.dataset.q));
      await change(item.key, n);
      return;
    }
    if (e.target.closest('[data-cur-co-close]') || e.target === dlg) dlg.close();
  });

  dlg.addEventListener('change', async (e) => {
    const box = e.target.closest('[data-offer]');
    if (!box) return;
    box.disabled = true;
    dlg.classList.add('is-busy');
    try { await addLines([{ id: Number(box.dataset.offer), quantity: 1 }], { quiet: true }); } catch {}
    await load();
    dlg.classList.remove('is-busy');
    render();
  });

  $('[data-cur-co-apply]').addEventListener('click', async () => {
    const code = form.discount.value.trim();
    const msg = $('[data-cur-co-disc-msg]');
    if (!code) return;
    msg.textContent = 'Se verifică…';
    cart = await post('/cart/update.js', { discount: code });
    const hit = (cart.discount_codes || []).find((d) => d.code.toLowerCase() === code.toLowerCase());
    msg.textContent = hit?.applicable ? '✓ Cod aplicat' : 'Codul nu este valid pentru această comandă';
    msg.classList.toggle('is-ok', !!hit?.applicable);
    render();
    refreshCart().catch(() => {});
  });

  // Details remembered in this browser only (so a returning customer doesn't retype).
  const fields = ['first_name', 'last_name', 'phone', 'province', 'city', 'address1', 'email'];
  const restore = () => { try { const d = JSON.parse(localStorage.getItem(KEY) || '{}'); fields.forEach((f) => { if (d[f] && !form[f].value) form[f].value = d[f]; }); } catch {} };

  const phoneOk = (v) => /^(\+?40|0)?7\d{8}$/.test(v.replace(/[\s.-]/g, ''));

  // COD order through our app. Returns the app's answer, or null when the app can't be used for this
  // cart / is unreachable (caller then falls back to Shopify's checkout).
  const COD_API = 'https://api.magazinultarii.ro/api/cod/order';
  const STORE_ERRORS = /invalid store|store configuration|shopify api|failed to create|draft order|limit/i;
  async function codOrder(d) {
    const goods = cart.items.filter((i) => i.variant_id !== gift.variant);
    const main = goods[0];
    if (!main || main.quantity > 10) return null;
    const units = (i) => Array(i.quantity).fill(i.variant_id);
    // The free gift goes in at 0 lei only when the cart already gives it free (gift rule met).
    const gifts = cart.items.filter((i) => i.variant_id === gift.variant);
    const giftIds = gifts.flatMap(units);
    const giftOff = gifts.flatMap((i) => Array(i.quantity).fill(((i.original_price - i.final_price) / 100).toFixed(2)));
    const ft = { 'Metodă de plată aleasă': 'Plata la livrare', _ft_url: location.href };
    document.querySelectorAll('input[name^="_ft_"]').forEach((el) => { if (el.value) ft[el.name] = el.value; });
    const body = {
      shop: window.Shopify?.shop || '1prggg-f4.myshopify.com',
      product_id: main.product_id,
      variant_id: main.variant_id,
      quantity: main.quantity,
      variant_ids: goods.flatMap(units),
      upsell_variant_ids: giftIds,
      upsell_discounts: giftOff,
      first_name: d.first_name,
      last_name: d.last_name,
      phone: `0${d.phone.replace(/\D/g, '').slice(-9)}`,
      province: form.province.selectedOptions[0]?.text || d.province,
      city: d.city,
      address1: d.address1,
      email: d.email,
      shipping_price: ((cart.total_price >= cfg.freeFrom ? 0 : cfg.shipping) / 100).toFixed(2),
      discount_code: form.discount.value.trim(),
      custom_fields: ft,
    };
    try {
      const r = await fetch(COD_API, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
      if (!r.ok) return null;
      const res = await r.json();
      return !res.success && STORE_ERRORS.test(res.error || '') ? null : res;
    } catch { return null; }
  }

  function thankYou(orderName) {
    form.innerHTML = `
      <header class="cur-co__head"><h2 class="cur-co__title">Mulțumim! Comanda ta a fost plasată</h2>
        <button type="button" class="cur-co__x" data-cur-co-close aria-label="Închide">×</button></header>
      <p class="cur-co__thanks">Comanda <strong>${esc(orderName)}</strong> a fost înregistrată. Plătești la livrare, iar
        curierul ajunge în 1–2 zile lucrătoare. Te putem suna pentru confirmare.</p>
      <button type="button" class="cur-co__btn cur-co__btn--cod" data-cur-co-close><span>Înapoi la magazin</span></button>`;
    // the form markup is gone and the cart is empty: start fresh once the pop-up closes
    dlg.addEventListener('close', () => location.reload(), { once: true });
  }
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const err = $('[data-cur-co-err]');
    const bad = fields.filter((f) => form[f].required && !form[f].value.trim());
    if (form.phone.value && !phoneOk(form.phone.value)) bad.push('phone');
    if (form.email.value && !form.email.checkValidity()) bad.push('email');
    form.querySelectorAll('.is-bad').forEach((el) => el.classList.remove('is-bad'));
    bad.forEach((f) => form[f].classList.add('is-bad'));
    if (bad.length) {
      err.textContent = 'Completează câmpurile marcate.';
      err.hidden = false;
      form[bad[0]].focus();
      return;
    }
    err.hidden = true;
    const d = Object.fromEntries(fields.map((f) => [f, form[f].value.trim()]));
    try { localStorage.setItem(KEY, JSON.stringify(d)); } catch {}
    const pay = e.submitter?.dataset.pay || 'ramburs';
    e.submitter?.classList.add('is-loading');
    if (pay !== 'card') {
      dlg.classList.add('is-busy');
      const res = await codOrder(d);
      dlg.classList.remove('is-busy');
      if (res?.success) {
        await post('/cart/clear.js', {}).catch(() => {});
        refreshCart?.().catch(() => {});
        thankYou(res.order_name);
        return;
      }
      if (res) { // the app answered with a customer-facing problem (phone, duplicate order…)
        e.submitter?.classList.remove('is-loading');
        err.textContent = res.error || 'Comanda nu a putut fi plasată. Încearcă din nou.';
        err.hidden = false;
        return;
      }
      // null → app unavailable for this cart: continue to Shopify's checkout as before
    }
    await post('/cart/update.js', { attributes: { 'Metodă de plată aleasă': pay === 'card' ? 'Card' : 'Plata la livrare' } }).catch(() => {});
    const digits = d.phone.replace(/[^\d+]/g, '');
    const phone = digits.startsWith('+') ? digits : `+40${digits.replace(/^(40|0)/, '')}`;
    const q = new URLSearchParams({
      'checkout[shipping_address][first_name]': d.first_name,
      'checkout[shipping_address][last_name]': d.last_name,
      'checkout[shipping_address][address1]': d.address1,
      'checkout[shipping_address][city]': d.city,
      'checkout[shipping_address][province]': d.province,
      'checkout[shipping_address][country]': 'RO',
      'checkout[shipping_address][phone]': phone,
    });
    if (d.email) q.set('checkout[email]', d.email);
    const code = form.discount.value.trim();
    if (code) q.set('discount', code);
    location.href = `/checkout?${q.toString()}`;
  });

  const open = async () => {
    await load();
    if (!cart.item_count) return;
    restore();
    render();
    document.getElementById('cart-drawer')?.close?.();
    dlg.showModal();
  };
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-cur-checkout-open]');
    if (!t) return;
    e.preventDefault();
    open();
  });
  window.curOpenCheckout = open;
}
